import React, { useState } from "react";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { ExternalLink, ChevronRight } from "lucide-react";
import { PolarityBadge, WarStanceBadge } from "./StanceBadge";
import StatementDetail from "./StatementDetail";
import { formatDateTR } from "../lib/constants";

export default function StatementFeed({ statements, countriesByCode, onRefreshCountry, refreshing }) {
  const [openStmt, setOpenStmt] = useState(null);
  return (
    <div className="space-y-3" data-testid="statement-feed">
      {statements.length === 0 && (
        <div className="text-center text-gray-400 py-12 font-mono text-sm">
          Filtreye uygun açıklama yok.
        </div>
      )}
      {statements.map((s) => {
        const c = countriesByCode[s.country_code];
        return (
          <Card key={s.id} className="rounded-sm bg-[#141414] border-white/10 p-4 hover:bg-[#1F1F1F] transition-colors"
                data-testid={`statement-${s.country_code}`}>
            <div className="flex items-start gap-4">
              <img src={c?.flag_url} alt={c?.name_tr}
                   className="h-7 w-10 object-cover rounded-sm border border-white/10 mt-1 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-heading text-white text-sm">{c?.name_tr || s.country_code}</span>
                  <span className="text-gray-600">·</span>
                  <span className="data-label">{c?.ministry_tr || ""}</span>
                  <span className="ml-auto" />
                  <PolarityBadge polarity={s.polarity} />
                  <WarStanceBadge stance={s.war_stance} />
                </div>
                <div className="mt-1.5 text-white font-heading text-base leading-snug" data-testid="feed-headline">
                  {s.headline_tr || "—"}
                </div>
                <p className="text-sm text-gray-300 mt-1 leading-relaxed line-clamp-2">
                  {s.summary_tr}
                </p>
                <div className="flex items-center gap-3 mt-2 text-[11px] font-mono text-gray-400 flex-wrap">
                  <span>{formatDateTR(s.statement_date)}</span>
                  <span className="text-gray-700">|</span>
                  <span>{s.source}</span>
                  {s.tone_tr && <><span className="text-gray-700">|</span><span className="text-orange-300">Ton: {s.tone_tr}</span></>}
                  {s.source_url && (
                    <a href={s.source_url} target="_blank" rel="noreferrer"
                       className="inline-flex items-center gap-1 text-blue-400 hover:text-blue-300"
                       onClick={(e) => e.stopPropagation()}>
                      Kaynak <ExternalLink className="h-3 w-3" />
                    </a>
                  )}
                  <Button size="sm" variant="ghost"
                          className="ml-auto h-7 text-xs text-gray-300 hover:text-white hover:bg-white/5"
                          onClick={() => setOpenStmt(s)}
                          data-testid={`open-detail-${s.id}`}>
                    Detay <ChevronRight className="h-3 w-3 ml-1" />
                  </Button>
                </div>
              </div>
            </div>
          </Card>
        );
      })}
      <StatementDetail
        open={!!openStmt} onClose={() => setOpenStmt(null)}
        country={openStmt ? countriesByCode[openStmt.country_code] : null}
        statement={openStmt}
        onRefresh={onRefreshCountry} refreshing={refreshing}
      />
    </div>
  );
}
